import { render, staticRenderFns } from "./ForestParFr.vue?vue&type=template&id=3a38b932&scoped=true"
import script from "./ForestParFr.vue?vue&type=script&lang=js"
export * from "./ForestParFr.vue?vue&type=script&lang=js"
import style0 from "./ForestParFr.vue?vue&type=style&index=0&id=3a38b932&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a38b932",
  null
  
)

export default component.exports